import { workflowsRepo } from '@/constants/providers';
import { BusinessAreasKey } from '@/modules/BusinessAreas/queries/keys';
import { CompanyKeys } from '@/modules/Companies/queries';
import { OrganizationKeys } from '@/modules/Organizations/queries/keys';
import { ProcessKey } from '@/modules/Processes/queries';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { CreateWorkflowJson, WorkflowSchemaType } from '../types';
import { WorkflowKey } from './keys';

export const useCreateWorkflow = (onSuccess: () => void = () => {}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { mutate, isLoading } = useMutation<void, unknown, CreateWorkflowJson>(
    (workflow) => workflowsRepo.createWorkflow(workflow),
  );

  const submit = (data: WorkflowSchemaType) => {
    const convertedData: CreateWorkflowJson = {
      name: data.workflowName,
      description: data.description,
      businessAreaId: data.businessAreaId,
      processId: data.processId,
      status: true,
    };

    mutate(convertedData, {
      onError: () => {
        toast.error(t('error_creating_workflow'));
      },
      onSuccess: () => {
        onSuccess();
        queryClient.invalidateQueries(WorkflowKey.ALL);
        queryClient.invalidateQueries(OrganizationKeys.ALL);
        queryClient.invalidateQueries(BusinessAreasKey.ALL);
        queryClient.invalidateQueries(CompanyKeys.ALL);
        queryClient.invalidateQueries(ProcessKey.ALL);
        toast.success(t('success_creating_workflow'));
      },
    });
  };

  return { submit, isSubmitting: isLoading };
};
